<script lang="ts">import { onMount, onDestroy } from 'svelte';
import { scrollState } from '../../../../js-v2/stores/scroll-state-store';
// eslint-disable-next-line prefer-const
let { isPast = $bindable(), hiddenUntilScrolled = false } = $props();
let waypoint = $state();
let observer;
onMount(() => {
    observer = new IntersectionObserver(onIntersection);
    observer.observe(waypoint);
});
onDestroy(() => {
    if (observer) {
        observer.unobserve(waypoint);
    }
});
function onIntersection(entries) {
    isPast = entries[0].boundingClientRect.top < 0;
    scrollState.setWaypointPassed(isPast);
}
</script>

<div class="Waypoint" class:hiddenUntilScrolled bind:this={waypoint}></div>

<style>
  .hiddenUntilScrolled {
    position: absolute;
    top: 100vh;
  }
</style>
